// extracted by mini-css-extract-plugin
export var button = "button-module--button--KCsdZ";